import { render, staticRenderFns } from "./UnsubscribeResult.vue?vue&type=template&id=0daca0ac&scoped=true"
import script from "./UnsubscribeResult.vue?vue&type=script&lang=js"
export * from "./UnsubscribeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daca0ac",
  null
  
)

export default component.exports